export const CLASS_LABELS = {//0: 'BG',    //Because BG is the default class and not actually a car part
    1: 'back_bumper',
    2: 'back_door',
    3: 'back_glass',
    4: 'dicky',
    5: 'fender',
    6: 'front_bumper',
    7: 'front_door',
    8: 'front_glass',
    9: 'headlight',
    10: 'hood',
    11: 'qtr_panel',
    12: 'running_board',
    13: 'side_view_mirror',
    14: 'taillight',
    15: 'wheel',
    16: 'window_glass'
}



export const ALL_MAJOR_PARTS = ["fender", "front_bumper", "window_glass", "hood", "front_bumper_isometric",
    "front_glass", "qtr_panel", "back_bumper", "dicky", "back_bumper_isometric",
    "back_glass", "front_door", "back_door", "running_board"]


export const REGIONS = {
    FRONT: "Front",
    FRONT_ISOMETRIC_LEFT: "Front-Isometric-Left",
    FRONT_ISOMETRIC_RIGHT: "Front-Isometric-Right",
    SIDE_LEFT: "Side-Left",
    SIDE_RIGHT: "Side-Right",
    REAR: "Rear",
    REAR_ISOMETRIC_RIGHT: "Rear-Isometric-Right",
    REAR_ISOMETRIC_LEFT: "Rear-Isometric-Left",
}

export const REGION_COVERAGE_STATUS = {
    NOT_COVERED: 0,
    PARTIALLY_COVERED: 1,
    FULLY_COVERED: 2,
}
export const MAX_NUMBER_OF_FRAME_PER_REGION = {
    'Front': 4,
    'Rear': 4,
    'Side-Left': 5,
    'Side-Right': 5,
    'Front-Isometric-Left': 4,
    'Front-Isometric-Right': 4,
    'Rear-Isometric-Right': 4,
    'Rear-Isometric-Left': 4
}

export const MAX_NUMBER_OF_FRAME_PER_REGION_SHORT = {
    'Front': 2,
    'Rear': 2,
    'Side-Left': 3,
    'Side-Right': 3,
    'Front-Isometric-Left': 2,
    'Front-Isometric-Right': 2,
    'Rear-Isometric-Right': 2,
    'Rear-Isometric-Left': 2
}

export const PERFECT_ANGLE_PER_REGION = {
    'Front': 0,
    'Rear': 180,
    'Side-Left': 270,
    'Side-Right': 90,
    'Front-Isometric-Left': 315,
    'Front-Isometric-Right': 45,
    'Rear-Isometric-Right': 135,
    'Rear-Isometric-Left': 225
}

export const START_FLAG = "_START_"

export const DIGILERA_CLIET_LIST = ["clientiopt.test1.1"]

export const IMGFEEDBACK = {
    "ImageAnalysisMssg1": "It will take some time to analyse the images. Please continue to capture other sections",
    "OtherBtnTxt": "Other Sections",
    "ReasonTxt": "Reason:",
    "RecaptureBtnTxt": "Recapture image",
    "ImageAnalysisMssg2": "Please wait for some time while we analyse the images",
    "recaptureMssg": "One-time analysis: click red section to recapture incorrect images.",
    "ImageAnalysisCompleteText": "Analysis is completed please click on submit and upload button.",
    "ReasonMssg": {
        "The image captured was blurry.": "The image captured was blurry.",
        "The image was captured in low light condition.": "The image was captured in low light condition.",
        "Please stand close to the car to capture the zoomed out image.": "Please stand close to the car to capture the zoomed out image.",
        "Please stand away from the car to capture the zoomed out image.": "Please stand away from the car to capture the zoomed out image.",
        "Please recapture the VIN to clearly show 17 digits.": "Please recapture the VIN to clearly show 17 digits.",
        "You did not capture these parts in the image:": "You did not capture these parts in the image:",
        "back bumper": "back bumper",
        "front bumper": "front bumper",
        "front door": "front door",
        "back door": "back door",
        "dicky": "dicky",
        "front glass": "front glass",
        "back glass": "back glass",
        "fender": "fender",
        "qtr panel": "qtr panel",
        "hood": "hood",
        "window glass": "window glass",
        "taillight": "taillight",
        "headlight": "headlight",
        "fog light": "fog light",
        "wheel": "wheel",
        "wheel rim": "wheel rim",
        "license plate": "license plate",
        "You captured the wrong side. Please capture # again.": "You captured the wrong side. Please capture # again.",
        "You captured the wrong side. You captured # in stead of # .": "You captured the wrong side. You captured # in stead of # .",
        "Front side": "Front side",
        "Front Left side": "Front Left side",
        "Left side": "Left side",
        "Back Left side": "Back Left side",
        "Back side": "Back side",
        "Back Right side": "Back Right side",
        "Right side": "Right side",
        "Front Right side": "Front Right side"
    }
}

export const IMG360CONFIG = {
    "name": "",
    "id": "360 Image",
    "tag": "360 Image",
    "link": "https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/app-icon/-_360+view.svg",
    "subSections": true,
    "mandatory": true,
    "fallBackBlock": true,
    "description": "This is 360 Image module",
    "values": [
        {
            "name": "Front Capture",
            "image": "https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/app-icon/-_Front.svg",
            "stencils": "https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/stencils/-_Front.svg",
            "tag": "Front Capture",
            "mandatory": true
        },
        {
            "name": "Front Left Capture",
            "image": "https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/app-icon/-_Front+left.svg",
            "stencils": "https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/stencils/-_Front+left.svg",
            "tag": "Front Left",
            "mandatory": true
        },
        {
            "name": "Left Capture",
            "image": "https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/app-icon/-_Left.svg",
            "stencils": "https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/stencils/-_Left.svg",
            "tag": "Left Capture",
            "mandatory": true
        },
        {
            "name": "Back Left Capture",
            "image": "https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/app-icon/-_Back+left.svg",
            "stencils": "https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/stencils/-_Back+left.svg",
            "tag": "Back Left",
            "mandatory": true
        },
        {
            "name": "Back Capture",
            "image": "https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/app-icon/-_Back.svg",
            "stencils": "https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/stencils/-_Back.svg",
            "tag": "Back Capture",
            "mandatory": true
        },
        {
            "name": "Back Right Capture",
            "image": "https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/app-icon/-_Back+right.svg",
            "stencils": "https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/stencils/-_Back+right.svg",
            "tag": "Back Right",
            "mandatory": true
        },
        {
            "name": "Right Capture",
            "image": "https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/app-icon/-_Right.svg",
            "stencils": "https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/stencils/-_Right.svg",
            "tag": "Right Capture",
            "mandatory": true
        },
        {
            "name": "Front Right Capture",
            "image": "https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/app-icon/-_Front+right.svg",
            "stencils": "https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/stencils/-_Front+right.svg",
            "tag": "Front Right",
            "mandatory": true
        }
    ]
};